import React, { useMemo } from "react";
import LogisticsCompanyNameMap from "@/map/LogisticsCompanyNameMap";
import { BaseOptionType } from "antd/lib/select";
import { useRequest } from "ahooks";
import { getProviderViewEwaybillAccountList } from "@/services/api/ewaybillAccount";
import EwaybillTypeNameMap from "@/map/EwaybillTypeNameMap";
import { uniq } from "lodash";
import LogisticsCompany from "@/enum/LogisticsCompany";

function useProviderEwaybillAccountOptions() {
  const { data: ewaybillAccountList, loading } = useRequest(() => getProviderViewEwaybillAccountList());

  const result = useMemo(() => {
    const ewaybillAccountOptions: BaseOptionType[] = [
      {
        value: null,
        label: "全部",
      },
    ];

    const logisticsCompanyOptions: BaseOptionType[] = [
      {
        value: null,
        label: "全部",
      },
    ];

    const ewaybillBranchAccountOptions: BaseOptionType[] = [
      {
        value: null,
        label: "全部",
      },
    ];

    const logisticsCompanies = [];

    ewaybillAccountList?.forEach((it) => {
      ewaybillAccountOptions.push({
        value: it.id,
        label: `${it.name ?? it.platformUsername}${it.username ? `/${it.username}` : ""}(${
          EwaybillTypeNameMap[it.type]
        })`,
      });

      it.subscriptions.forEach((subscription) => {
        subscription.branchAccounts.forEach((branchAccount) => {
          if (subscription.logisticsCompany) {
            logisticsCompanies.push(subscription.logisticsCompany);
          }

          ewaybillBranchAccountOptions.push({
            value: branchAccount.id,
            label: `${LogisticsCompanyNameMap[subscription.logisticsCompany]}/${branchAccount.branchName || ""}(${
              branchAccount.branchCode
            })`,
          });
        });
      });
    });

    uniq(logisticsCompanies).forEach((logisticsCompany) => {
      logisticsCompanyOptions.push({
        value: logisticsCompany,
        label: LogisticsCompanyNameMap[logisticsCompany],
      });
    });

    return {
      ewaybillAccountOptions,
      ewaybillBranchAccountOptions,
      logisticsCompanyOptions,
    };
  }, [ewaybillAccountList]);

  function getFilterLogisticsCompanyOptions(selectedEwaybillAccountId?: number) {
    if (selectedEwaybillAccountId) {
      const logisticsCompanyOptions: BaseOptionType[] = [
        {
          value: null,
          label: "全部",
        },
      ];

      const logisticsCompanies = [];

      ewaybillAccountList?.forEach((it) => {
        if (it.id === selectedEwaybillAccountId) {
          it.subscriptions.forEach((subscription) => {
            subscription.branchAccounts.forEach((branchAccount) => {
              if (subscription.logisticsCompany) {
                logisticsCompanies.push(subscription.logisticsCompany);
              }
            });
          });
        }
      });

      uniq(logisticsCompanies).forEach((logisticsCompany) => {
        logisticsCompanyOptions.push({
          value: logisticsCompany,
          label: LogisticsCompanyNameMap[logisticsCompany],
        });
      });

      return logisticsCompanyOptions;
    }

    return result.logisticsCompanyOptions;
  }

  function getFilterEwaybillBranchAccountOptions(
    selectedEwaybillAccountId?: number,
    selectedLogisticsCompany?: LogisticsCompany
  ) {
    if (selectedEwaybillAccountId && selectedLogisticsCompany) {
      const ewaybillBranchAccountOptions: BaseOptionType[] = [
        {
          value: null,
          label: "全部",
        },
      ];

      ewaybillAccountList?.forEach((it) => {
        if (it.id === selectedEwaybillAccountId) {
          it.subscriptions.forEach((subscription) => {
            subscription.branchAccounts.forEach((branchAccount) => {
              if (subscription.logisticsCompany === selectedLogisticsCompany) {
                ewaybillBranchAccountOptions.push({
                  value: branchAccount.id,
                  label: `${LogisticsCompanyNameMap[subscription.logisticsCompany]}/${branchAccount.branchName || ""}(${
                    branchAccount.branchCode
                  })`,
                });
              }
            });
          });
        }
      });

      return ewaybillBranchAccountOptions;
    }

    return result.ewaybillBranchAccountOptions;
  }

  return {
    ...result,
    loading,
    getFilterLogisticsCompanyOptions,
    getFilterEwaybillBranchAccountOptions,
  };
}

export default useProviderEwaybillAccountOptions;
